import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { DarkModeContextProvider } from './context/darkModeContext';
import { AuthContextProvider } from './context/AuthContext';
import { SearchProvider } from './context/SearchContext';
import ErrorBoundary from './components/ErrorBoundary';
import { LoggedUserProvider } from './context/LoggedUserContext';

// In production builds, silence informational console output so auth/user
// details and API data never appear in the browser console on the live site.
// console.warn and console.error are kept for real problem reporting.
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
}

ReactDOM.render(
  <React.StrictMode>
    <DarkModeContextProvider>
      <AuthContextProvider>
        <SearchProvider>
          <LoggedUserProvider>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </LoggedUserProvider>
        </SearchProvider>
      </AuthContextProvider>
    </DarkModeContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
